import {DetailsHeader} from '@/components/commons/details-header/DetailsHeader'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledTreatmentRequestCode = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['500']};
    `
)

export const StyledTreatmentRequestDetailsHeader = styled(DetailsHeader)(
    () => css`
        padding-bottom: 0;
        width: 100%;
    `
)

export const StyledTreatmentRequestHeroSectionBody = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: 0 ${spacing * 4}px ${spacing * 4}px ${spacing * 4}px;
    `
)
